import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiDtgCarService
    ,FvmsApiDtgTeamService
    ,FvmsApiAuthService
    ,FvmsApiDtgUserService
} from "src/app/shared/service";
import {
    DtgActionType
} from "src/app/shared/vo";
import {
    DtgManageCompanySearchComponent
} from "src/app/dtg/manage/company/search/dtg.manage.company.search.component";

@Component({
    templateUrl: "./dtg.manage.car.form.component.html"
    ,providers: []
})
export class DtgManageCarFormComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    @Input() companyId:string;
    @Input() teamId:string;
    @Input() dtgUnitId:string;
    @Input() dtgActionType:DtgActionType;
    formGroup: FormGroup;
    submitted:boolean = false;
    readOnly:boolean = true;
    DtgActionType = DtgActionType;
    listCarType:any;
    listTeam:any;
    currentUserInfo:any;
    userGroupId:number;
    companyInfo:any;
    
    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
        ,private formBuilder: FormBuilder
        ,private fvmsApiDtgCarService:FvmsApiDtgCarService
        ,private fvmsApiDtgTeamService:FvmsApiDtgTeamService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgUserService:FvmsApiDtgUserService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
     }

    ngOnInit() {
        this.initForm();
        switch(this.dtgActionType){
            case DtgActionType.create:
                this.readOnly = false;
                this.reloadListItemTeam();
                break;
            case DtgActionType.update:
            case DtgActionType.delete:
                this.readOnly = false;
                this.selectOneCarInfo().then(() => {
                    this.reloadListItemTeam();
                });
                break;
            case DtgActionType.read:
            default:
                this.readOnly = true;
                this.selectOneCarInfo().then(() => {
                    this.reloadListItemTeam();
                });
                this.formGroup.disable();
                break;
        }
        this.reloadListItemCarType();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    initForm(){
        this.formGroup = this.formBuilder.group({
            dtgUnitId:this.dtgUnitId
            ,deviceTypeId:0
            ,dtgCarNo:null
            ,dtgVin:[
                null
                ,[
                    Validators.maxLength(17)
                    ,Validators.pattern("[a-zA-Z0-9]{0,17}")
                ]
            ]
            ,dtgCarType:"41"
            ,dtgCarTypeNm:null
            ,memo:null
            ,useYn:"Y"
            ,companyId:[
                this.companyId
                ,[
                    Validators.required
                ]
            ]
            ,companyNm:null
            ,dtgTeamId:null
            ,dtgTeamNm:null
            ,dtgDriverLcsNo:null
            ,userId:null
            ,userNm:null
            ,serviceDtFrom:null
            ,dtgEid:null
            ,dtgKcNo:null
            ,dtgDeviceSn:null
            ,dtgModelNo:null
            ,dtgFirmwareInfo:null
            ,updateDt:null
        });
    }

    get f() { return this.formGroup.controls; }

    selectOneCarInfo(){
        let promise = new Promise<void>((resolve) => {
            let searchInfo = {
                dtgUnitId : this.dtgUnitId
                // ,companyId : this.companyId
                // ,dtgTeamId : this.teamId
            };
            this.fvmsApiDtgCarService.getCarDetail(searchInfo)
                .pipe(takeWhile(() => this.isContinue))
                .subscribe(apiResponse => {
                    if(apiResponse.resultStatus === "ok"){
                        this.formGroup.patchValue(apiResponse.resultValue);
                        resolve();
                    }
                });
        });
        return promise;
    }

    // 셀렉트박스 차량종류
    reloadListItemCarType(){
        this.fvmsApiDtgCarService.getListCarType(null)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listCarType = apiResponse.resultValue;
                    this.listCarType = this.listCarType.filter((val,idx) => val.dtgCarType !== "0");
                }
            });
    }

    // 셀렉트박스 그룹목록
    reloadListItemTeam(){
        let searchInfo = {
            companyId : this.f.companyId.value || this.companyId
            ,dtgTeamId : this.f.dtgTeamId.value || this.currentUserInfo.teamId
            ,searchValue : null
        };
        let pagingInfoTeam = {
            "curPage":1
            ,"pageSize":1000
        };
        this.fvmsApiDtgTeamService.getListTeam(searchInfo,pagingInfoTeam)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listTeam = apiResponse.resultValue;
                }
            });
    }

    clickOpenModalCompanyInfo(dtgActionType:DtgActionType){
        let modalRef = this.modalService.open(
            DtgManageCompanySearchComponent
            ,{
                centered:true
                ,size: "sm"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                // console.log("clickOpenModalCompanyInfo",resultModal.companyInfo);
                if(resultModal.companyInfo.companyId !== this.f.companyId.value){
                    this.formGroup.patchValue({
                        companyId : resultModal.companyInfo.companyId
                        ,companyNm : resultModal.companyInfo.companyNm
                    });
                    let searchInfo = {
                        companyId:resultModal.companyInfo.companyId
                        ,dtgUnitId:this.f.dtgUnitId.value
                    };
                    this.fvmsApiDtgCarService.moveDtgCarCompany(searchInfo)
                        .pipe(takeWhile(() => this.isContinue))
                        .subscribe(apiResponse => {
                            this.activeModal.close({
                                "result":"ok"
                            });
                        });
                }
            }
        });
    }

    cntVin(){
        if(!this.f.dtgVin.value){
            return 0;
        }
        return this.f.dtgVin.value.length;
    }

    cntEid(){
        if(!this.f.dtgEid.value){
            return 0;
        }
        return this.f.dtgEid.value.length;
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    clickSave(){
        this.onSubmit();
    }

    onSubmit(){
        this.submitted = true;
        // console.log("onSubmit",this.f);
        if (this.formGroup.invalid) {
            return;
        }

        let carInfo = {
            dtgUnitId:this.f.dtgUnitId.value
            ,companyId:this.f.companyId.value
            ,dtgTeamId:this.f.dtgTeamId.value
            ,deviceTypeId:this.f.deviceTypeId.value
            ,dtgCarType:this.f.dtgCarType.value
            ,dtgCarNo:this.f.dtgCarNo.value
            ,dtgModelNo:this.f.dtgModelNo.value
            ,memo:this.f.memo.value
            ,useYn:this.f.useYn.value
            ,createUser:this.currentUserInfo.userId
            ,updateUser:this.currentUserInfo.userId
            ,userId:this.f.userId.value
        };
        // console.log("onSubmit",carInfo);

        this.fvmsApiDtgCarService.upsertCar(carInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    console.log("new car id",apiResponse.resultValue.dtgUnitId);
                    // 사용자 차량 운행 등록
                    // this.fvmsApiDtgUserService.upsertUserCarRunLast(carInfo)
                    //     .pipe(takeWhile(() => this.isContinue))
                    //     .subscribe(apiResponse2 => {
                    //         // console.log("new user id",apiResponse2.resultValue.userId);
                    //     });
                }

                this.activeModal.close({
                    "result":"ok"
                });
            });
        return;
    }
}